type Severity = 'INFO' | 'WARN' | 'ERROR';

interface LogEntry {
  requestId: string;
  userId: string;
  serverName: string;
  functionName: string;
  time: string;
  message: string;
  severity: Severity;
}

/**
 *
 * Logs messages with different severity levels
 *
 * @param severity - The severity level of the log (INFO, WARN, ERROR)
 * @param message - The log message
 * @param requestId - The request ID
 * @param userId - The user ID
 * @param serverName - The server name
 * @param functionName - The function name where the log is called
 */
const logger = (
  severity: Severity,
  message: string,
  requestId: string,
  userId: string,
  serverName: string,
  functionName: string,
) => {
  const logEntry: LogEntry = {
    requestId,
    userId,
    serverName,
    functionName,
    time: new Date().toISOString(),
    message,
    severity,
  };

  switch (severity) {
    case 'INFO':
      console.info(logEntry);
      break;
    case 'WARN':
      console.warn(logEntry);
      break;
    case 'ERROR':
      console.error(logEntry);
      break;
    default:
      console.log(logEntry);
  }
};

export default logger;
